import { useEffect, useState } from "react";
import { getBrandDetails } from "./requests";
import { getCardTypeDetails } from "./parseBrandDetails";

export const useGetBrandDetails = (pathname) => {
  const [isLoading, setIsLoading] = useState(true);
  const [brandDetails, setBrandDetails] = useState(null);

  const brandNameRegex = /\/buy-(.*?)-gift-cards/i;
  const brandName = (() => pathname.match(brandNameRegex)[1])();

  useEffect(() => {
    const fetchBrandDetails = async () => {
      try {
        const brandDetails = await getBrandDetails(brandName);
        const { cardType, productSourceId } = brandDetails;
        const isApple = productSourceId === "37";

        setBrandDetails({
          ...brandDetails,
          isApple,
          cardTypeDescription: getCardTypeDetails({ cardType })
        });
      } catch (error) {
        setBrandDetails(null);
      } finally {
        setIsLoading(false);
      }
    };
    void fetchBrandDetails();
  }, [brandName]);

  return {
    isLoading,
    brandDetails
  };
};
